import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { useSession } from '@/lib/session'
import { Logo } from '@/components/Logo'

export default function CoachLogin() {
  const navigate = useNavigate()
  const { signIn, ready } = useSession()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    setError(null)
    setBusy(true)
    const { error } = await signIn(email.trim(), password)
    setBusy(false)
    if (error) {
      setError(error)
      return
    }
    // Land on home; role-based routing sends athletes to their own workout and
    // coaches to the athlete-search splash.
    navigate('/')
  }

  return (
    <div className="hero-glow relative flex min-h-full flex-col items-center justify-center px-6 py-16">
      <form onSubmit={submit} className="w-full max-w-sm animate-fade-in">
        <div className="mb-10 text-center">
          <Logo className="mx-auto h-16" />
          <p className="mt-4 font-condensed text-xs uppercase tracking-[0.35em] text-muted">
            Sign In
          </p>
        </div>

        {!ready && (
          <p className="mb-4 rounded-btn border border-warning/30 bg-warning/10 px-3 py-2 text-center text-xs text-warning">
            Database not configured (missing env).
          </p>
        )}

        <label className="mb-1.5 block font-condensed text-[11px] uppercase tracking-[0.2em] text-muted">
          Email
        </label>
        <Input
          type="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@fromzero.com"
          className="mb-4"
        />

        <label className="mb-1.5 block font-condensed text-[11px] uppercase tracking-[0.2em] text-muted">
          Password
        </label>
        <Input
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
        />

        {error && <p className="mt-3 text-sm text-danger">{error}</p>}

        <Button type="submit" block size="lg" className="mt-6" disabled={busy || !ready}>
          {busy ? 'Signing in…' : 'Sign In'}
        </Button>

        <button
          type="button"
          onClick={() => navigate('/')}
          className="mt-5 w-full text-center text-xs uppercase tracking-[0.2em] text-muted hover:text-gold"
        >
          ‹ Back
        </button>
      </form>
    </div>
  )
}
